<template>
  <div @mouseenter="mouseenter" @mouseleave="mouseleave">
    <slot v-bind="{ photos, selectedPhoto, selectPhoto }"></slot>
  </div>
</template>
<script>
import Swiper from 'swiper/bundle'
import $ from 'cash-dom'

export default {
  props: {
    photos: {
      type: Object
    }
  },
  data () {
    return {
      swiper: null,
      selectedPhoto: Object.keys(this.$props.photos).length ? this.$props.photos[Object.keys(this.$props.photos)[0]] : null
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (Object.keys(this.$props.photos).length == 0) return

      this.swiper = new Swiper($(this.$el).find('.article-gallery__container')[0], {
        slidesPerView: 'auto',
        spaceBetween: 10,
        speed: 750,
        loop: false,
        autoplay: {
          delay: 4000
        },
        navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev'
        }
      })
    })
  },
  methods: {
    mouseenter () {
      if (this.swiper && this.swiper.autoplay) {
        this.swiper.autoplay.stop()
      }
    },
    mouseleave () {
      if (this.swiper && this.swiper.autoplay) {
        this.swiper.autoplay.start()
      }
    },
    selectPhoto (image) {
      this.selectedPhoto = image
    }
  }
}
</script>